import {useFormValue} from '@yandex-delivery/nlf-form/v2'
import {useMemo} from 'react'

import type {Order} from 'src/shared/types'

import {useDestinationPointsCoordinates} from '../../../hooks/use-destination-points-coordinates'
import {useSourcePointCoordinates} from './use-source-point-coordinates'

export function useOrderPointsCoordinates() {
  const verticalName = useFormValue<Order, 'offerFlow.vertical.name'>('offerFlow.vertical.name')
  const sourcePointCoordinates = useSourcePointCoordinates()
  const destinationPointCoordinates = useDestinationPointsCoordinates()

  const sourcePointHash = JSON.stringify(sourcePointCoordinates)
  const destinationPointsHash = JSON.stringify(destinationPointCoordinates)

  return useMemo(() => {
    const destinationPoints =
      verticalName === 'night' ? destinationPointCoordinates.slice(0, 1) : destinationPointCoordinates
    return [sourcePointCoordinates, ...destinationPoints]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verticalName, sourcePointHash, destinationPointsHash])
}
